export default __webpack_public_path__ + "static/media/2020-2.3e6b311b.jpg";